export default function getRelationshipStringKeyFromAscendancyNumber(
  ascendancyNumber,
  stringType = 'relationshipTitle'
) {
  const strs = {
    self: {
      yearBorn: 'aam.tiles.year-you-were-born',
      yearTurnedAge: 'aam.tiles.year-you-were-born',
      relationshipTitle: '',
    },
    child: {
      yearBorn: 'aam.tiles.year-your-child-born',
      yearTurnedAge: 'aam.tiles.year-your-child-turned-age',
      relationshipTitle: 'relationship.child',
    },
    son: {
      yearBorn: 'aam.tiles.year-your-son-born',
      yearTurnedAge: 'aam.tiles.year-your-son-turned-age',
      relationshipTitle: 'relationship.son',
    },
    daughter: {
      yearBorn: 'aam.tiles.year-your-daughter-born',
      yearTurnedAge: 'aam.tiles.year-your-daughter-turned-age',
      relationshipTitle: 'relationship.daughter',
    },
    wife: {
      yearBorn: 'aam.tiles.year-your-wife-born',
      yearTurnedAge: 'aam.tiles.year-your-wife-turned-age',
      relationshipTitle: 'relationship.wife',
    },
    husband: {
      yearBorn: 'aam.tiles.year-your-husband-born',
      yearTurnedAge: 'aam.tiles.year-your-husband-turned-age',
      relationshipTitle: 'relationship.husband',
    },
    father: {
      yearBorn: 'aam.tiles.year-your-father-born',
      yearTurnedAge: 'aam.tiles.year-your-father-turned-age',
      relationshipTitle: 'relationship.father',
    },
    fathersFather: {
      yearBorn: 'aam.tiles.year-your-fathers-father-born',
      yearTurnedAge: 'aam.tiles.year-your-fathers-father-turned-age',
      relationshipTitle: 'relationship.fathers-father',
    },
    fathersMother: {
      yearBorn: 'aam.tiles.year-your-fathers-mother-born',
      yearTurnedAge: 'aam.tiles.year-your-fathers-mother-turned-age',
      relationshipTitle: 'relationship.fathers-mother',
    },
    fathersFathersFather: {
      yearBorn: 'aam.tiles.year-your-fathers-fathers-father-was-born',
      yearTurnedAge: 'aam.tiles.year-your-fathers-fathers-father-turned-age',
      relationshipTitle: 'relationship.fathers-fathers-father',
    },
    fathersFathersMother: {
      yearBorn: 'aam.tiles.year-your-fathers-fathers-mother-was-born',
      yearTurnedAge: 'aam.tiles.year-your-fathers-fathers-mother-turned-age',
      relationshipTitle: 'relationship.fathers-fathers-mother',
    },
    fathersMothersFather: {
      yearBorn: 'aam.tiles.year-your-fathers-mothers-father-was-born',
      yearTurnedAge: 'aam.tiles.year-your-fathers-mothers-father-turned-age',
      relationshipTitle: 'relationship.fathers-mothers-father',
    },
    fathersMothersMother: {
      yearBorn: 'aam.tiles.year-your-fathers-mothers-mother-was-born',
      yearTurnedAge: 'aam.tiles.year-your-fathers-mothers-mother-turned-age',
      relationshipTitle: 'relationship.fathers-mothers-mother',
    },

    mother: {
      yearBorn: 'aam.tiles.year-your-mother-born',
      yearTurnedAge: 'aam.tiles.year-your-mother-turned-age',
      relationshipTitle: 'relationship.mother',
    },
    mothersFather: {
      yearBorn: 'aam.tiles.year-your-mothers-father-born',
      yearTurnedAge: 'aam.tiles.year-your-mothers-father-turned-age',
      relationshipTitle: 'relationship.mothers-father',
    },
    mothersMother: {
      yearBorn: 'aam.tiles.year-your-mothers-mother-born',
      yearTurnedAge: 'aam.tiles.year-your-mothers-mother-turned-age',
      relationshipTitle: 'relationship.mothers-mother',
    },
    mothersFathersFather: {
      yearBorn: 'aam.tiles.year-your-mothers-fathers-father-was-born',
      yearTurnedAge: 'aam.tiles.year-your-mothers-fathers-father-turned-age',
      relationshipTitle: 'relationship.mothers-fathers-father',
    },
    mothersFathersMother: {
      yearBorn: 'aam.tiles.year-your-mothers-fathers-mother-was-born',
      yearTurnedAge: 'aam.tiles.year-your-mothers-fathers-mother-turned-age',
      relationshipTitle: 'relationship.mothers-fathers-mother',
    },
    mothersMothersFather: {
      yearBorn: 'aam.tiles.year-your-mothers-mothers-father-was-born',
      yearTurnedAge: 'aam.tiles.year-your-mothers-mothers-father-turned-age',
      relationshipTitle: 'relationship.mothers-mothers-father',
    },
    mothersMothersMother: {
      yearBorn: 'aam.tiles.year-your-mothers-mothers-mother-was-born',
      yearTurnedAge: 'aam.tiles.year-your-mothers-mothers-mother-turned-age',
      relationshipTitle: 'relationship.mothers-mothers-mother',
    },
  }

  const gender = ascendancyNumber % 2 === 0 ? 'male' : 'female'
  let i = ascendancyNumber
  let genCount = 0
  const isPersonMale = gender === 'male'
  let titleStr = ''
  let greatCount = 0

  if (ascendancyNumber === '1-S') {
    titleStr = isPersonMale ? strs.husband[stringType] : strs.wife[stringType]
  } else if (typeof ascendancyNumber === 'string' && ascendancyNumber.includes('1.')) {
    titleStr = strs.child[stringType]
  } else if (ascendancyNumber === 1 || ascendancyNumber === '1') {
    titleStr = strs.self[stringType]
  } else if (ascendancyNumber > 1) {
    // If ascendancy number indicates "self" then we don't need to do all this
    while (i > 0) {
      if (i % 2 === 0) {
        i /= 2 // Male
      } else {
        i = (i - 1) / 2 // Female
      }
      genCount++
    }

    if (genCount > 2) {
      for (let j = 2; j < genCount; j++) {
        if (j > 2) {
          greatCount++
        }
      }

      const an = parseInt(ascendancyNumber, 10)

      switch (an) {
        case 4:
          titleStr = strs.fathersFather[stringType]
          break
        case 5:
          titleStr = strs.fathersMother[stringType]
          break
        case 6:
          titleStr = strs.mothersFather[stringType]
          break
        case 7:
          titleStr = strs.mothersMother[stringType]
          break
        case 8:
          titleStr = strs.fathersFathersFather[stringType]
          break
        case 9:
          titleStr = strs.fathersFathersMother[stringType]
          break
        case 10:
          titleStr = strs.fathersMothersFather[stringType]
          break
        case 11:
          titleStr = strs.fathersMothersMother[stringType]
          break
        case 12:
          titleStr = strs.mothersFathersFather[stringType]
          break
        case 13:
          titleStr = strs.mothersFathersMother[stringType]
          break
        case 14:
          titleStr = strs.mothersMothersFather[stringType]
          break
        case 15:
          titleStr = strs.mothersMothersMother[stringType]
          break
        default:
          break
      }

      if (greatCount === 2) {
        titleStr = isPersonMale ? 'relationship.2nd-great-grandfather' : 'relationship.2nd-great-grandmother'
      } else if (greatCount === 3) {
        titleStr = isPersonMale ? 'relationship.3rd-great-grandfather' : 'relationship.3rd-great-grandmother'
      } else if (greatCount === 4) {
        titleStr = isPersonMale ? 'relationship.4th-great-grandfather' : 'relationship.4th-great-grandmother'
      } else if (greatCount === 5) {
        titleStr = isPersonMale ? 'relationship.5th-great-grandfather' : 'relationship.5th-great-grandmother'
      } else if (greatCount === 6) {
        titleStr = isPersonMale ? 'relationship.6th-great-grandfather' : 'relationship.6th-great-grandmother'
      }
    } else {
      titleStr = isPersonMale ? strs.father[stringType] : strs.mother[stringType]
    }
  } else {
    titleStr = ''
  }
  return titleStr
}
